import { createSlice } from "redux-starter-kit";

export interface FeedsSeoContent {
    visible: boolean;
}

const initialState: FeedsSeoContent = {
    visible: true,
};

const feedSeoContent = createSlice({
    slice: "feedsShowSeoContent",
    initialState,
    reducers: {
        showSeoContent(state): void {
            state.visible = true;
        },
        hideSeoContent(state): void {
            state.visible = false;
        },
    },
});

const { actions, reducer } = feedSeoContent;
export const { showSeoContent, hideSeoContent } = actions;
export default reducer;
